var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgExposiciones(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "Capa_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 200 200",
    style: {
      enableBackground: "new 0 0 200 200"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#831131",
    d: "M164.01,31.4h-59.93L96.37,4.4L89.05,31.4H21.22v94.3H63.5l-17.74,65.45l3.4,0.92l9.87-36.4h63.27v-3.52H59.98l7.17-26.44  h60.21l18,63.02l3.39-0.97l-17.73-62.05h32.99V31.4z M96.46,17.54l3.96,13.85h-7.71L96.46,17.54z M24.74,118.94l33.62-36.57  l39.86,39.8H24.74V118.94z M76.7,95.7l24.43-28.66l50.11,55.13h-48.02L76.7,95.7z M160.49,122.17H156l-54.95-60.46L74.2,93.2  L58.25,77.29l-33.51,36.45V34.92h135.75V122.17z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgExposiciones);
export default __webpack_public_path__ + "static/media/exposiciones.82e0498dbb4a697d15f7adc76627c93e.svg";
export { ForwardRef as ReactComponent };